import React, { useState, useEffect } from 'react';
import { Megaphone, X } from 'lucide-react';
import { apiGet } from '../lib/apiClient';

/**
 * Displays the latest active announcements as a dismissible banner on the dashboard.
 * Dismissed announcement IDs are stored in localStorage so they don't reappear.
 */
export default function AnnouncementsBanner() {
  const [announcements, setAnnouncements] = useState([]);
  const [dismissed, setDismissed] = useState(() => {
    try { return JSON.parse(localStorage.getItem('dismissed_announcements') || '[]'); }
    catch { return []; }
  });

  useEffect(() => {
    const token = localStorage.getItem('access_token');
    if (!token) return;
    apiGet('/api/announcements')
      .then(d => { if (d?.announcements) setAnnouncements(d.announcements); })
      .catch(() => {});
  }, []);

  const dismiss = (id) => {
    const next = [...dismissed, id];
    setDismissed(next);
    localStorage.setItem('dismissed_announcements', JSON.stringify(next));
  };

  const visible = announcements.filter(a => !dismissed.includes(a.id));
  if (!visible.length) return null;

  return (
    <div className="space-y-2 mb-4">
      {visible.map((a) => (
        <div
          key={a.id}
          className="flex items-start gap-3 px-4 py-3 rounded-xl border"
          style={{
            background: 'linear-gradient(135deg, rgba(16,185,129,0.08), rgba(20,184,166,0.04))',
            borderColor: 'rgba(16,185,129,0.25)',
          }}
        >
          <div className="w-8 h-8 rounded-lg bg-emerald-500/15 flex items-center justify-center flex-shrink-0">
            <Megaphone size={15} className="text-emerald-400" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-semibold text-gray-100">{a.title}</p>
            <p className="text-xs text-gray-400 mt-0.5 leading-relaxed">{a.message}</p>
          </div>
          <button
            onClick={() => dismiss(a.id)}
            className="text-gray-500 hover:text-gray-300 flex-shrink-0 p-1"
            aria-label="Dismiss announcement"
          >
            <X size={15} />
          </button>
        </div>
      ))}
    </div>
  );
}
